/* eslint-disable */
import { useState, useEffect, useRef }  from 'react';
import { Link }                 from 'react-router-dom';
import AuthorizationContext     from 'auth/keycloak-instance';
import useTranslate             from 'app/common/hooks/translate';
import Dropdown                 from 'app/common/uikit/dropdown';
import { 
	useDispatch
}                               from 'react-redux';
import { 
    useSelector,
    shallowEqual 
}                               from 'react-redux';

const ApplicationHeader = props => {
    const p                 = props;       
	const dispatch 			= useDispatch();
    const t                 = useTranslate();
    const redux             = useSelector( state => ({
        displayLanguage                : state.provider.displayLanguage
    }), shallowEqual)

    const changeLanguage = language => {
        localStorage.setItem('displayLanguage', language);
        dispatch({
            type        : 'provider/changeLanguage',
            payload     : language
        });
    }

    return (
        <div className="application-wrapper-header">
            <div className="logo-wrapper full">
                <a className="back" href="/"></a>
            </div>
            <div className="application-wrapper-header-navigation">
                <div className="support-button">
                    <span></span>
                    <label>{ t('Support') }</label>
                    <div className="support-popover">
                        <div className="support-popover-header">{ t('Support') }</div>
                        <p>{ t('Support_WhatsApp_Text') }</p>
                        <a className="support-whatsapp-button" href="https://api.whatsapp.com/send/?phone=908503337675" target="_blank" rel="noreferrer">{ t('Support_WhatsApp_Button') }</a>
                        <img src={ require('assets/images/whatsapp-qr.png') } alt="WhatsApp QR" />
                    </div>
                </div>
                <div className="profile-button">
                    <span></span>
                    <label>{ AuthorizationContext.user.profile?.firstName } { AuthorizationContext.user.profile?.lastName }</label>
                    <div className="profile-menu-container">
                        <Link to="/profile-settings">{ t('Profile_Settings') }</Link>
                        <Link to="#" onClick={ () => p.togglePermissionModal() }>{ t('My_Permissions') }</Link>
                        <Link to="#" onClick={ () => AuthorizationContext.logout() } className="logout">{ t('Sign_Out') }</Link>
                    </div>
                </div>
                <Dropdown
                    options     = {[
                        { text: 'English', value: 'en' },
                        { text: 'Türkçe', value: 'tr' },
                        { text: 'Deutsch', value: 'de' },
                        { text: 'Français', value: 'fr' },
                        { text: 'Русский', value: 'ru' },
                        { text: 'العربية', value: 'ar' },
                        { text: '中文', value: 'zh' },
                        { text: 'Svenska', value: 'sv' },
                        { text: 'Dansk', value: 'da' },
                        { text: 'Suomi', value: 'fi' },
                        { text: 'Norsk', value: 'no' },
                        { text: 'Magyar', value: 'hu' },
                        { text: 'Hrvatski', value: 'hr' },
                        { text: 'Македонски', value: 'mk' },
                        { text: 'Azərbaycan', value: 'az' },
                        { text: 'Қазақ', value: 'kk' },
                        { text: 'Íslenska', value: 'is' }
                    ]}
                    onChange    = { option => changeLanguage(option.value) }
                    value       = { redux.displayLanguage }
                />
            </div>
        </div>
    )
}

export default ApplicationHeader
/* eslint-enable */